import React, { FC } from 'react';
import { Route, Redirect, Switch } from 'react-router';
import { PublicHomePage } from '../Pages/PublicHomePage';
import { PostLogOutPage } from '../Pages/PostLogOutPage';
import { TvAndSecurityRedirect } from '../Pages/TvAndSecurityRedirect';
import { EmailManagementRedirect } from '../Pages/EmailManagementRedirect';
import { UserServicesPage } from '../Pages/UserServicesPage';
import { withOidcSecure } from '@axa-fr/react-oidc-context';
import { pages } from '../Constants/Pages';
import { CalendarPage } from '../Pages/CalendarPage/CalendarPage';
import { CalenderProductListPage } from '../Pages/CalendarProductListPage';
import { NotFound } from '../Pages/NotFound';
import { ChangePassword } from '../Pages/ChangePassword/ChangePassword';

export const Routes: FC = () => (
	<Switch>
		<Route exact component={PublicHomePage} path={pages.home} />
		<Route exact component={NotFound} path={pages.notFound} />
		<Route exact component={PostLogOutPage} path={pages.post_signout} />

		<Route exact component={withOidcSecure(TvAndSecurityRedirect)} path={pages.TvAndSecurity} />
		<Route exact component={withOidcSecure(EmailManagementRedirect)} path={pages.emailService} />
		<Route exact component={withOidcSecure(ChangePassword)} path={pages.change_password} />
		<Route
			exact
			component={withOidcSecure(CalendarPage)}
			path={pages.broadband + '/:orderid/:orderrowid'}
		/>
		<Route exact component={withOidcSecure(CalenderProductListPage)} path={pages.broadbandList} />
		<Route exact component={withOidcSecure(UserServicesPage)} path={pages.services} />

		<Redirect to={pages.services}></Redirect>
	</Switch>
);
